import { Component, Input, OnInit, input, ChangeDetectionStrategy } from '@angular/core';
import { JkBaseComponent } from '../jkbase/jkbase.component';
import { CdkDrag, //CdkDragHandle,
   DragDropModule } from '@angular/cdk/drag-drop';
import { JkcheckboxComponent } from '../jkcheckbox/jkcheckbox.component';

/**
 * 彈出式文字區域組件
 *
 * 一個可拖曳的彈出式文字區域組件，用於顯示和編輯較長的文字內容。
 * 此組件提供了兩種大小模式（大型和小型）和可彈出顯示的功能，
 * 讓用戶能夠更方便地處理和查看長文字資料。
 */
@Component({
  selector: 'app-jkpopup-textarea',
  standalone: true,
  imports: [
    DragDropModule,
    JkcheckboxComponent,
    CdkDrag,
    //CdkDragHandle,
],
  templateUrl: './jk-popup-textarea.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './jk-popup-textarea.component.scss'
})
export class JkPopupTextareaComponent extends JkBaseComponent implements OnInit {
  override comType: string = 'popup-textarea';

  /** 組件位置值 */
  _position: number = 1;

  /**
   * 獲取組件位置值
   * @returns 位置數值
   */
  // TODO: Skipped for migration because:
  //  Accessor inputs cannot be migrated as they are too complex.
  @Input() get position(): number{
    return this._position;
  }

  /**
   * 設定組件位置值
   * @param value 位置數值
   */
  set position(value: number) {
    this._position = value;
  }

  /** 文字區域內容 */
  readonly value = input<string>('');

  /** 是否為大型文字區域 */
  _isLarge: boolean = false;

  /**
   * 獲取是否為大型文字區域
   * @returns 是否為大型
   */
  get isLarge(): boolean {
    return this._isLarge;
  }

  /**
   * 設定是否為大型文字區域
   * 設定後會自動更新CSS類別
   * @param value 是否為大型
   */
  set isLarge(value: boolean) {
    this._isLarge = value;
    if(this._isLarge) {
      // if(this.position === 1)
      // this.textareaClass = 'textareaLarge'
      // else
      this.textareaClass = 'textareaLarge';
    }else{
      // if(this.position === 1)
      // this.textareaClass = 'textareaSmall'
      // else
      this.textareaClass = 'textareaSmall';
    }
  }
  /** 是否為彈出模式 */
  _isPopup: boolean = false;

  /**
   * 獲取是否為彈出模式
   * @returns 是否為彈出模式
   */
  get isPopup(): boolean {
    return this._isPopup;
  }

  /**
   * 設定是否為彈出模式
   * @param value 是否為彈出模式
   */
  set isPopup(value: boolean) {
    this._isPopup = value;
  }

  /** 文字區域CSS類別名稱 */
  textareaClass: string = 'textareaSmall';

  /**
   * 元件初始化
   */
  OnInit() {
  }
}

